import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Gallery from './components/Gallery';
import QuoteForm from './components/QuoteForm';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App" id="home">
      <Header />
      <Hero />
      <About />
      <Services />
      <Gallery />
      <QuoteForm />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
